import React, { useContext, useEffect, useState } from 'react'
import HeaderWithSelect from 'app/react/components/HeaderWithSelect'
import TypographyContext from 'app/react/components/typography/TypographyContext'
import Fonts from 'app/react/components/typography/Fonts'

export default function TypographyContent () {

  const { headerTitle, headerText, selectLabel, selectOptions, setSelectedOption, fonts } = useContext(TypographyContext)
  const [realSelectOptions, setRealSelectOptions] = useState(selectOptions)

  if (fonts.length === 0) return

  const handleOnSelectChange = (e) => {
    setSelectedOption(e.target.value)
  }

  const filterOptions = () => {
    const typesArray = []
    for (let i = 0; i < fonts.length; i++) {
      const types = fonts[i].types
      for (const key in types) {
        if (typesArray.indexOf(key) === -1) {
          typesArray.push(key)
        }
      }
    }

    const realSelectOptions = selectOptions.filter((item, i) => {
      return typesArray.indexOf(item.value) !== -1
    })
    
    setRealSelectOptions(realSelectOptions)
  }

  useEffect(() => {
    filterOptions()
  }, [])

  return (
    <section id="typography" className="dm-typography">
      <div className="dm-typography__inner dm-page-container">
        <HeaderWithSelect
          title={headerTitle}
          text={headerText}
          label={selectLabel}
          selectOptions={realSelectOptions}
          onSelectChange={handleOnSelectChange}
        />
        <Fonts/>
      </div>
    </section>
  )
}